import React from 'react';
import Skeleton from 'react-loading-skeleton';

import './GetGoingSkeleton.scss';

export const GetGoingButtonSkeleton = () => (
    <>
        <div className="get-going-skeleton desktop">
            <Skeleton style={{ width: 342, height: 40, borderRadius: 24 }} />
        </div>
        <div className="get-going-skeleton mobile">
            <Skeleton style={{ width: 136, height: 40, borderRadius: 24 }} />
        </div>
    </>
);
